import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import Home from './Components/Home';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Layout from './Components/Layout';
import Login from './Components/Login'
import Products from './Components/Products';
import SingleProduct from './Components/SingleProduct';
import Admin from './Components/Admin';
import ProtectedRoutes from './Components/ProtectedRoutes';
import LoopingParagraph from './Components/FullStop';
import Representative from './Components/Representative';
// import OrdersListener from './Components/Notify';
import AddProduct from './Components/AddProduct';
import Dashboard from './Components/Dashboard';
import { LanguageProvider } from "./Components/Context/LanguageContext"; // Import the provider
import ManageRep from './Components/ManageRep';
import RepProfile from './Components/RepProfile';
import AdminRepProfile from './Components/AdminRepProfile';
import ComingSoon from './Components/ComingSoon';
import AboutUs from './Components/AboutUs';
import CeoMessage from './Components/CeoMessage';
import JoinUs from './Components/JoinUs';
// Set this to true to show maintenance page, false to show the normal app
const MAINTENANCE_MODE = false;

function App() {
  // If maintenance mode is enabled, show the ComingSoon component
  if (MAINTENANCE_MODE) {
    return <ComingSoon />;
  }

  const routes = createBrowserRouter([
    // Define Dashboard separately so it's not wrapped in Layout
    { 
      path: "dashboard", 
      element: <ProtectedRoutes allowedRoles={['admin', 'accountant', 'storekeeper']}>
                <Dashboard />
              </ProtectedRoutes> 
    },
    { 
      path: "RepProfile", 
      element: <ProtectedRoutes allowedRoles={['representative']}>
                <RepProfile />
              </ProtectedRoutes> 
    },
    // Other routes that are wrapped with Layout
    {
      path: "/",
      element: <Layout />,
      children: [
        { index: true, element: <Home /> },
        { path: "Login", element: <Login /> },
        { path: "about-us", element: <AboutUs /> },
        { path: "join-us", element: <JoinUs /> },
        { path: "CeoMessage", element: <CeoMessage /> },
        { 
          path: "add-product", 
          element: <ProtectedRoutes allowedRoles={['admin', 'storekeeper']}>
                    <AddProduct />
                  </ProtectedRoutes> 
        },
        { 
          path: "Manage-Rep", 
          element: <ProtectedRoutes allowedRoles={['admin']}>
                    <ManageRep />
                  </ProtectedRoutes> 
        },
        { path: "Products", element: <Products /> },
        { path: "OurRepresentative", element: <Representative /> },
        { 
          path: "Admin", 
          element: <ProtectedRoutes allowedRoles={['admin']}>
                    <Admin />
                  </ProtectedRoutes> 
        },
        { path: "Products/SingleProduct/:productId", element: <SingleProduct /> },
        { 
          path: "dashboard/AdminRepProfile/:repId", 
          element: <ProtectedRoutes allowedRoles={['admin']}>
                    <AdminRepProfile />
                  </ProtectedRoutes> 
        },
        { path: "test", element: <LoopingParagraph /> },
        { path: "*", element: <Home /> },
      ],
    },
  ]);
  

  return (
    <LanguageProvider>
      <RouterProvider router={routes}/>
    </LanguageProvider>
  );
}

export default App;
